<template>
  <div class="titulo">
    <b-img src="/images/FONDOS.jpg" fluid class="img-titulo"></b-img>
    <h4 class="texto-titulo">{{titulo}}</h4>
    <div >
      <Breadcrumb :list="list" />
    </div>
  </div>
</template>


<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
export default {
  name: "Titulo",
   components: {
      Breadcrumb,
  },
  props: {
    titulo: String
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  }
};
</script>